// extracted by mini-css-extract-plugin
export default {"nameCell":"ExpenseGroupsTable_nameCell__oWC+x","descriptionCell":"ExpenseGroupsTable_descriptionCell__+vrsZ"};